<div class="order-pricing-wrapper">
    <div class="card">
        <div class="card-header">
            <span class="pull-left"><span translate="cart.order.history.order.number"></span>&nbsp;{{orderView.id}}</span>
        </div>
        <div class="card-body order-summary">
            <span class="fw-bold" translate="cart.order.history.order.status"></span>
            <span class="text-capitalize fw-bold">{{'cart.order.history.order.status.' + orderView.status.toLowerCase() | translate}}</span>
            <span translate="cart.order.history.order.total"></span><span>{{orderView.total | usanacurrency: orderView.currencyCode | async}}</span>
            <span *ngIf="displayVolume" translate="cart.order.history.order.total.volume"></span><span *ngIf="displayVolume">{{orderView.totalVolume}}</span>
            <span translate="cart.order.history.order.source"></span>
            <span translate="{{'cart.order.history.source.' + orderView.source}}"></span>
        </div>
    </div>
    <div class="panel-action" [ngSwitch]="trackingCount">
        <span class="no-action" *ngSwitchCase="0"></span>
        <div *ngSwitchCase="1" class="action">
            <a *ngIf="!!trackingLink" target="_blank" [href]="trackingLink">
                <button type="button" class="btn btn-primary" [attr.analytics-value]="trackingNumber">
                    <span class="fw-bold" translate="cart.order.history.track.package"></span>
                    <i class="fa-solid fa-arrow-up-right-from-square margin-left-8" aria-hidden="true"></i>
                </button>
            </a>
        </div>
        <div *ngSwitchDefault class="action">
            <a (click)="openOrderTrackingModal(orderView)">
                <button type="button" class="btn btn-primary">
                    <span class="fw-bold" translate="cart.track.packages"></span>
                </button>
            </a>
        </div>
        <a class="btn btn-secondary" *ngIf="orderView.source === 'APO'"
                [ngClass]="{'disabled-tag': !canAutoOrder}"
                [routerLink]="canAutoOrder ? [AUTO_ORDER_MANAGE_ROUTE] : null">
            <span class="fw-bold" translate="cart.order.history.manage.auto.order"></span>
        </a>
        <span class="tooltip-wrapper"
              [tooltip]="'cart.order.history.cannot.add.order' | translate"
              [isDisabled]="canAddToCart && !isAddingToCart">
            <button type="button" class="btn btn-warning"
                    [disabled]="!canAddToCart || isAddingToCart"
                    (click)="addFullOrder.emit(orderView.products)">
                <span class="fw-bold" translate="cart.order.history.add.order.to.cart"></span>
            </button>
        </span>
    </div>
</div>
